<template>
  <el-dialog
    class="small-dialog"
    @close="handleClose"
    :title="`${operateCn}`"
    :visible="programmeInfo.visible"
    :close-on-click-modal="false"
    v-dialogDrag
  >
    <el-form :model="formData" :rules="formRules" label-width="160px" ref="formRef">
      <el-form-item label="方案编码" prop="code">
        <el-input
          placeholder="请输入方案编码"
          v-model.trim="formData.code"
          size="small"
          clearable
          maxlength="100"
        ></el-input>
      </el-form-item>
      <el-form-item label="方案名称" prop="name">
        <el-input
          placeholder="请输入方案名称"
          v-model.trim="formData.name"
          size="small"
          clearable
          maxlength="200"
        ></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="isEnable">
        <el-switch v-model.trim="formData.isEnable"> </el-switch>
      </el-form-item>
      <el-form-item label="Logo" prop="logo">
        <el-upload
          :disabled="isReadOperate"
          class="avatar-uploader relative cursor-pointer"
          action="https://XX.YY.ZZ"
          accept="image/png,image/jpeg"
          :show-file-list="false"
          :http-request="uploadLogo"
          :multiple="false"
        >
          <img
            class="avatar-result"
            v-if="formData.logo || isReadOperate"
            :src="formData.logoUrl"
            width="100%"
            height="100%"
          />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
    </el-form>
    <div slot="footer" class="text-center" v-if="!isReadOperate">
      <el-button type="primary" size="small" @click="save" :loading="saveLoading">保存</el-button>
      <el-button size="small" @click="handleClose">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { SchemeApi } from '@wiz-api/cloud-render-management'
import { FileApi } from '@wiz-api/file-management'

const fileApi = new FileApi()

const schemeApi = new SchemeApi()
export default {
  name: 'programme-dialog',
  components: {},
  props: {
    programmeInfo: {
      type: Object,
      default: () => {
        return {
          operateType: '新增方案',
          visible: false,
          formData: {
            code: '',
            name: '',
            isEnable: true,
          },
        }
      },
    },
  },
  data() {
    return {
      // 保存加载状态
      saveLoading: false,
      // 请求表单
      formData: {
        code: '',
        name: '',
        isEnable: true,
        logoUrl: null,
        logo: '',
      },
      // 表单验证
      formRules: {
        code: { required: true, message: '请输入方案编码', trigger: 'change' },
        name: { required: true, message: '请输入方案名称', trigger: 'change' },
        logo: { required: false, message: '请上传Logo图片', trigger: 'change' },
        isEnable: { required: false, message: '请选择默认开启板块', trigger: 'change' },
      },
      // 关闭方案数据
      closeProgramme: null,
    }
  },
  async created() {
    const formData = _.get(this.programmeInfo, 'formData')
    if (!_.isEmpty(formData)) {
      this.formData = _.cloneDeep(formData)
      if (formData.logo) {
        const [error, result] = await fileApi.getFileContent(formData.logo)
        if (!error) {
          this.$set(this.formData, 'logoUrl', `data:image/jpg;base64,${result.content}`)
        }
      }
    }
  },
  computed: {
    // 是否为查看详情
    isReadOperate() {
      return _.eq(this.programmeInfo.operateType, 'read')
    },
    // 弹框标题
    operateCn() {
      const cnOperate = {
        create: '新增方案',
        update: '编辑方案',
        read: '方案详情',
      }
      return _.get(cnOperate, this.programmeInfo.operateType) || '新增'
    },
  },
  methods: {
    // 上传logo
    async uploadLogo(e) {
      const [err, res] = await fileApi.upload({
        files: [e.file],
      })
      if (!err) {
        this.formData.logo = res[0].id
        const [error, result] = await fileApi.getFileContent(res[0].id)
        if (!error) {
          this.formData.logoUrl = `data:image/jpg;base64,${result.content}`
        }
      }
    },
    // 关闭弹框
    handleClose() {
      this.$emit('update:programmeInfo', _.assign(this.programmeInfo, { visible: false }))
    },
    // 保存
    save() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) {
          return
        }
        if (this.formData.id) {
          this.editProgramme()
          return
        }
        this.addProgramme()
      })
    },
    // 编辑方案
    async editProgramme() {
      try {
        this.saveLoading = true
        const body = _.cloneDeep(this.formData)
        // 关闭操作，无需查询已存在开启方案
        if (body.isEnable) {
          // // 关闭当前方案后，开启当前操作方案
          await this.closeCureentProgramme()
        }
        const [err, res] = await schemeApi.update(body.id, {
          body,
        })
        this.saveLoading = false
        if (!err) {
          // 保存成功后，清空数据和方案
          this.$message.success('保存成功')
          this.$emit('update:programmeInfo', _.assign(this.programmeInfo, { visible: false }))
          // 新增获取第一页新数据
          this.$emit('updateList', 'edit')
          return
        }
        this.resetClosedProgramme()
      } catch (error) {
        this.resetClosedProgramme()
      }
    },
    // 新建方案
    async addProgramme() {
      try {
        this.saveLoading = true
        const body = _.cloneDeep(this.formData)
        // 关闭操作，无需查询已存在开启方案
        if (body.isEnable) {
          // // 关闭当前方案后，开启当前操作方案
          await this.closeCureentProgramme()
        }
        const [err, res] = await schemeApi.create({ body })
        this.saveLoading = false
        if (!err) {
          // 保存成功后，清空数据和方案
          this.$message.success('保存成功')
          this.$emit('update:programmeInfo', _.assign(this.programmeInfo, { visible: false }))
          // 新增获取第一页新数据
          this.$emit('updateList')
          return
        }
        this.resetClosedProgramme()
      } catch (error) {
        this.resetClosedProgramme()
      }
    },
    // 恢复关闭的方案
    async resetClosedProgramme() {
      // 新增开启方案失败后，开起关闭的方案
      if (this.closeProgramme) {
        await this.changeOpenStatus(this.closeProgramme, true)
        this.closeProgramme = null
      }
    },
    // 查询开启方案并关闭
    async closeCureentProgramme() {
      const [err, res] = await schemeApi.getList({
        isEnable: true,
        maxResultCount: 1,
        skipCount: 0,
      })
      if (!err && res) {
        const currentProgramme = _.head(res.items)
        if (!_.isEmpty(currentProgramme)) {
          await this.changeOpenStatus(currentProgramme, false)
        }
        return Promise.resolve('')
      }
      return Promise.reject(new Error('fail'))
    },
    // 是否显示名称切换
    async changeOpenStatus(data, isEnable) {
      // 兼容页面加载方式
      const params = _.clone(data)
      const [err, res] = await schemeApi.update(params.id, {
        body: { ...params, isEnable },
      })
      if (!err) {
        this.closeProgramme = _.cloneDeep(data)
        return Promise.resolve('')
      }
      return Promise.reject(new Error('fail'))
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  .el-input,
  .el-select,
  .el-input-number {
    max-width: 440px;
    width: 100%;
    line-height: 36px;
    .el-input__inner {
      text-align: left;
    }
    .el-input-number__decrease {
      line-height: 18px;
    }
    .el-input-number__increase {
      line-height: 17px;
    }
  }
}
.avatar-uploader ::v-deep .el-upload {
  overflow: hidden;
}
.avatar-uploader ::v-deep .el-upload:hover,
.avatar-uploader-icon:hover {
  border-color: #409eff;
  color: #409eff;
}
.avatar-uploader-icon,
.avatar-uploader-button {
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  width: 148px;
  height: 148px;
  font-size: 24px;
  line-height: 146px;
  vertical-align: top;
}
.avatar-uploader-button,
.avatar-uploader-button:hover {
  padding: 0 !important;
  border: none !important;
}
.avatar-result,
.avatar {
  width: 148px;
  height: 148px;
  display: block;
}
</style>
